// extracted by mini-css-extract-plugin
export default {"tableToolbar":"WSTableToolbar-module_tableToolbar-Ga3Ga"};